export default __webpack_public_path__ + "static/media/Preview_mobile_sel.4ecd0cf3.svg";